<template>
  <div @click="closePopup($event)" class="popper" id="popper">
    <div class="popped">
      <div id="page" class="main-item pops" v-if="(info || isNew)">
        <div class="black-top">
          <div class="top-menu">
            <h4
              class="item-head"
              style="transform: translateY(22px);"
            >{{isNew?'New Item':info.name}}</h4>
            <!-- <p class="date">{{info["updated-on"]?$parent.date(info["updated-on"]):''}}</p> -->
            <div class="right-buttons">
              <div data="status" class="top"></div>
              <div class="published hide"></div>
              <a @click="publish('draft')" href="#" class="button black w-button">Save as Draft</a>
              <a href="#" @click="publish()" class="button w-button">Publish</a>
            </div>
          </div>
        </div>
        <div v-if="schema && !loader" id="itempage" class="_700">
          <div v-for="(field,i) in schema" class="field" :key="field.slug">
            <label v-if="field.slug != 'slug'" class="item-label">
              {{field.name}}
              <span v-if="field.required" class="req">*</span>
            </label>
            <component
              :editable="field.editable"
              :is="field.type"
              :slg="field.slug"
              :fname="field.name"
              :validations="field.validations"
              :index="i"
              v-model="info[field.slug]"
            ></component>
          </div>
          <!-- <a
            v-if="info._archived"
            @click="publish(info._draft,false)"
            href="#"
            class="button grey w-button"
          >Restore Item</a>-->
          <!-- <a
            v-if="!isNew && !info._archived"
            @click="publish(info._draft,'archive')"
            href="#"
            class="button grey w-button"
          >Archive item</a>
          <a
            v-if="!isNew && info._archived"
            @click="deleteItem()"
            id="delete"
            href="#"
            class="button red w-button"
          >Perminantally delete this item</a>-->
        </div>

        <loader v-if="loader" zoom="1" />
      </div>
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.black-top {
  position: absolute;
  left: 0;
}
.main-item.pops {
  width: 100%;
  margin-left: 0;
  margin-top: 0;
  padding-top: 100px;
}
.popper {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 3;
  overflow: scroll;
}
.popped {
  z-index: 6;
  position: fixed;
  top: 10%;
  margin: auto;
  width: 90%;
  max-width: 1200px;
}
.pops.main-item {
  margin-right: auto;
  margin-left: auto;
}
.pops .black-top {
  right: 0;
}
div.blue-txt.top-marg5 {
  display: none !important;
}
._700 {
  margin: auto;
}
</style>


<script>
// @ is an alias to /src
//import tinymce from 'tinymce/tinymce.min'
//import tinymce from 'tinymce/tinymce.min'
//import 'tinymce/themes/silver/theme.min'
//import 'tinymce/themes/silver/skins'
//require.context('tinymce/skins', true, /.*/);
import RichText from "@/components/RichText.vue";
import ItemRef from "@/components/ItemRef.vue";
import ItemRefSet from "@/components/ItemRefSet.vue";
import Number from "@/components/Number.vue";
import PlainText from "@/components/PlainText.vue";
import Bool from "@/components/Bool.vue";
import Color from "@/components/Color.vue";
import Video from "@/components/Video.vue";
import Option from "@/components/Option.vue";
import Date from "@/components/Date.vue";
import ImageRef from "@/components/ImageRef.vue";
import Link from "@/components/Link.vue";
import loader from "@/components/loader.vue";
import FileRef from "@/components/FileRef.vue";

export default {
  name: "popup",
  props: ["poplink"],
  data() {
    return {
      ParentSlg: "",
      popsicle: true,
      schema: [],
      info: {},
      loader: true,
      isNew: false,
      Col: "",
      id: ""
    };
  },
  methods: {
    closePopup(e) {
      if ($(e.target).attr("id") == "popper") {
        this.$parent.popup = "";
      }
    },
    deleteCallback(inf) {
      this.loader = false;
      this.$emit("alertMessage", {
        type: inf.err ? "error" : "success",
        message: inf.err ? inf.problems[0] : "Deleted Successfully"
      });
      if (!inf.err) {
        this.$parent.popup = "";
      }
    },
    deleteItem() {
      if (
        window.confirm(
          "Are you sure you want to delete " + this.info.name + "?"
        )
      ) {
        this.loader = true;
        if (wfToken) {
          deleteItem.webflow(this.Col, this.id, this.deleteCallback);
        } else {
          deleteItem.firebase(this.Col, this.id, this.deleteCallback);
        }
      }
    },
    getSchema(Col) {
      var collection = this.$parent.collections.find(e => {
        return e["_id"] == Col;
      });
      $.each(collection.fields, (i, e) => {
        if (
          e.name != "Created On" &&
          e.name != "Archived" &&
          e.name != "Draft" &&
          e.name != "Updated On" &&
          e.name != "Published On" &&
          e.name != "Created By" &&
          e.name != "Updated By" &&
          e.name != "Published By" &&
          !e.name.match(/^-/)
        ) {
          this.schema.push(e);
          if (e.defaultValue) {
            this.info[e.slug] = e.defaultValue;
          }
          if (this.isNew) {
            this.info[e.slug] = "";
            this.loader = false;
          }
        }
      });
    },
    postPublish(inf) {
      var ParentCol = this.$route.params.col;
      var ParentId = this.$route.params.id;
      var ParentSlg = this.poplink.split("/")[2];
      var ParentType = this.poplink.split("/")[3];
      if (this.isNew) {
        if (ParentType == "sngl") {
          appItem.info[ParentSlg] = inf._id;
        } else {
          if (!appItem.info[ParentSlg]) {
            appItem.info[ParentSlg] = [];
          }
          appItem.info[ParentSlg].push(inf._id);
        }
      }
      this.$parent.popup = "";
    },
    publish(draft, archived) {
      this.loader = true;
      if (this.isNew) {
        this.info._archived = false;
        this.info._draft = false;
      }
      if (draft) {
        this.info._draft = true;
      } else {
        this.info._draft = false;
      }
      if (archived) {
        this.info._archived = true;
      } else {
        this.info._archived = false;
      }
      if (this.$parent.activeSite.type == "webflow") {
        console.log(this.info, this.Col, this.id);
        publish.webflow(this.info, this.Col, this.id, inf => {
          this.postPublish(inf);
        });
      } else {
        publish.firebase(this.info, this.Col, this.id, inf => {
          this.postPublish(inf);
        });
      }
    }
  },
  created() {
    this.ParentSlg = this.poplink.split("/")[2];
    this.Col = this.poplink.split("/")[0];
    this.id = this.poplink.split("/")[1];
    this.getSchema(this.Col);

    if (this.id != "new-item") {
      getdata.singleItem(this.Col, this.id, info => {
        this.info = info;
        this.loader = false;
      });
    } else {
      this.isNew = true;
      this.loader = false;
    }
  },
  components: {
    loader,
    FileRef,
    RichText,
    ItemRef,
    ItemRefSet,
    Number,
    PlainText,
    Bool,
    Color,
    Video,
    Option,
    Date,
    ImageRef,
    Link
  }
};
</script>